export default __webpack_public_path__ + "static/media/tree.999a9dfd.png";